import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireOwner?: boolean;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireOwner, requireAdmin }: ProtectedRouteProps) {
  const { firebaseUser, appUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!firebaseUser || !appUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (appUser.status === 'disabled') {
    return <Navigate to="/login" state={{ accountDisabled: true }} replace />;
  }

  const isPending =
    appUser.status === 'pending' || (appUser.companyId == null && appUser.role !== 'owner');
  const isPendingApprovalPage = location.pathname === '/pending-approval';
  if (isPending && !requireOwner && !isPendingApprovalPage) {
    return <Navigate to="/pending-approval" replace />;
  }

  if (requireOwner && appUser.role !== 'owner') {
    return <Navigate to="/app/dashboard" replace />;
  }

  if (requireAdmin && appUser.role !== 'admin' && appUser.role !== 'owner') {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
